import React, { useState } from 'react';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import PaperContainer from 'ui/PaperContainer';
import { withStyles } from '@material-ui/core/styles';

import EditSectionForm from 'ui/form/EditSectionForm';
import Fields from 'ui/form/FieldsForm';
import { Typography } from '@material-ui/core';

const styles = theme => ({
    contacts: {
        borderTop: 'solid 1px #dedefe',
    },
    contactSummary: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    contactSummaryIcon: {
        width: '30px',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        background: theme.palette.text.secondary,
        borderRadius: '50%',
        justifyContent: 'center',
        color: '#fff',
        margin: '0 16px 0 0',
    },
    contactSummaryInfo: {
        flex: '1 1 auto',
    },
    contactSummaryExpand: {},
});

const Actions = {
    UPDATE_PRIMARY: 'update.primary',
    UPDATE: 'update',
    ADD: 'add',
};

export default function PaymentsContact({ init, onSubmit, canEdit }) {
    const [contacts, setContacts] = useState([init]);

    const onAction = async (action, values) => {
        if (action === Actions.UPDATE_PRIMARY) {
            const contact = Object.assign(init, values);
            setContacts([contact]);
            return await onSubmit(contact);
        }
    };
    return (
        <PaperContainer title="Payments Contact" noBodyBorder>
            <Contacts
                contacts={contacts}
                onAction={onAction}
                canEdit={canEdit}
            />
        </PaperContainer>
    );
}

const Contacts = withStyles(styles)(
    ({ classes, contacts, onAction, canEdit }) => {
        return (
            <div className={classes.contacts}>
                <PaperContainer.Body>
                    {contacts.map(contact => {
                        return (
                            <PrimaryContactInfo
                                key={contact.email}
                                {...contact}
                                onAction={onAction}
                                canEdit={canEdit}
                            />
                        );
                    })}
                </PaperContainer.Body>
            </div>
        );
    }
);

const ContactInfo = withStyles(styles)(
    ({ classes, primary = false, name, email, children }) => {
        const [isOpen, setOpen] = useState(false);
        const toggle = () => setOpen(!isOpen);
        const label = primary ? 'Your info' : email;
        const summary = isOpen ? (
            label
        ) : (
            <React.Fragment>
                {name && <div className={classes.contactName}>{name}</div>}
                <div className={classes.contactEmail}>
                    <span>{email}</span>
                </div>
            </React.Fragment>
        );
        return (
            <div className={classes.contact}>
                <div className={classes.contactSummary} onClick={toggle}>
                    {!isOpen && (
                        <div className={classes.contactSummaryIcon}>
                            <MailOutlineIcon />
                        </div>
                    )}
                    <Typography
                        component="div"
                        className={classes.contactSummaryInfo}
                    >
                        {summary}
                    </Typography>
                    {primary && !isOpen && (
                        <Typography color="primary">You</Typography>
                    )}
                    <div className={classes.contactSummaryExpand}>
                        {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </div>
                </div>
                {isOpen && (
                    <div className={classes.contactBody}>{children}</div>
                )}
            </div>
        );
    }
);

function PrimaryContactInfo({
    first_name,
    last_name,
    email,
    onAction,
    canEdit,
}) {
    const [values, setValues] = useState({
        first_name,
        last_name,
        email,
    });
    const errors = {};
    const changeFactory = name => value =>
        setValues({ ...values, [name]: value });
    const name = `${first_name} ${last_name}`;
    return (
        <ContactInfo primary={false} name={name} email={email}>
            <EditSectionForm
                title="Contact details"
                icon={AccountCircleIcon}
                onSubmit={() => onAction(Actions.UPDATE_PRIMARY, values)}
                canEdit={canEdit}
            >
                <EditSectionForm.Preview>
                    {values.first_name} {values.last_name}
                    <br />
                    {values.email}
                </EditSectionForm.Preview>
                <EditSectionForm.Form>
                    <Fields.Text
                        label="First name"
                        value={values.first_name}
                        error={errors.first_name}
                        onChange={changeFactory('first_name')}
                    />
                    <Fields.Text
                        label="Last name"
                        value={values.last_name}
                        error={errors.last_name}
                        onChange={changeFactory('last_name')}
                    />
                    <Fields.Text
                        label="Email address"
                        value={values.email}
                        error={errors.email}
                        onChange={changeFactory('email')}
                    />
                </EditSectionForm.Form>
            </EditSectionForm>
        </ContactInfo>
    );
}
